import { apiGet, apiPost, apiPut, apiDelete } from "@/lib/api/client";
import type { PaginatedParams, PaginatedResponse } from "@/lib/api/types";

export const calendarApi = {
  listEvents: (params?: PaginatedParams & { startDate?: string; endDate?: string }) => {
    const searchParams = new URLSearchParams();
    if (params?.page) searchParams.set("page", String(params.page));
    if (params?.perPage) searchParams.set("perPage", String(params.perPage));
    if (params?.startDate) searchParams.set("startDate", params.startDate);
    if (params?.endDate) searchParams.set("endDate", params.endDate);
    return apiGet<PaginatedResponse<Record<string, unknown>>>(`/calendar/events?${searchParams.toString()}`);
  },

  getUpcoming: () => apiGet<{ data: Record<string, unknown>[] }>(`/calendar/events/upcoming`),

  getById: (id: string) => apiGet<{ data: Record<string, unknown> }>(`/calendar/events/${id}`),

  create: (body: Record<string, unknown>) => apiPost<{ data: Record<string, unknown> }>(`/calendar/events`, body),

  update: (id: string, body: Record<string, unknown>) => apiPut<{ data: Record<string, unknown> }>(`/calendar/events/${id}`, body),

  delete: (id: string) => apiDelete<{ data: Record<string, unknown> }>(`/calendar/events/${id}`),

  bulkDelete: (ids: string[]) => apiDelete<{ data: number }>(`/calendar/events/bulk-delete`, { data: { ids } }),

  getStats: () => apiGet<{ data: Record<string, unknown> }>(`/calendar/stats`),

  export: (format = "CSV") => apiGet<{ data: unknown }>(`/calendar/export?format=${format}`),
};